import RevisionService from '@/entities/revision/revision.service';
import AlertService from '@/shared/alert/alert.service';
import EntityFactory, { INivel } from '@/shared/insaculacion/entity-commons/entity.factory';
import { EstadoRevision } from '@/shared/model/enumerations/estado-revision.model';
import { NRecomendadoEnum } from '@/shared/model/enumerations/nivel-recomendado-enum.model';
import { TipoSolucion } from '@/shared/model/enumerations/tipo-solucion.model';
import { Respuesta } from '@/shared/model/respuesta.model';
import { Revision } from '@/shared/model/revision.model';
import { Revisor } from '@/shared/model/revisor.model';
import { SolicitudResumen } from '@/shared/model/solicitud-resumen.model';
import { ISolicitudRevision } from '@/shared/model/solicitud-revision.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { Solucion } from '@/shared/model/solucion.model';
import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';

/**
 * An utility service for RevisionMixin.
 * El componente que utilice este mixin requiere establecer la solicitud y la solución.
 * Se pueden establecer la solución usando otro mixin cómo SolucionMixin.
 */
@Component
export default class RevisionMixin extends Vue {
  @Inject('alertService') public alertService: () => AlertService;

  @Inject('revisionService') protected revisionService: () => RevisionService;

  public solicitud: Solicitud;

  @Prop({ required: false })
  public solucionPlenaria: Solucion;

  @Prop({ required: false, default: true })
  public evaluacionIndividual: boolean;

  public nivelRecomendado: Array<INivel> = EntityFactory.nivelesRecomendado;
  public recomendado: INivel = {};
  public evaluacion1: INivel = {};
  public evaluacion2: INivel = {};
  public evaluacion3: INivel = {};
  public idNoAprobado = NRecomendadoEnum.NO_APROBADO;

  public resumen: any = '';

  public clonado = false;

  public isPleno = false;

  public solicitudRevisiones: Array<ISolicitudRevision> = [];

  public validaNiveles = false;

  public tieneCandidato = false;

  public mostrarTieneCandidato = false;

  public resultadoCualitativoPrimera: any = '';
  public totalResultadoCualitativoPrimera = 0;

  public resultadoCualitativoSegunda: any = '';
  public totalResultadoCualitativoSegunda = 0;

  /// Se guardaran las valoraciones
  public valoracionesCualitativasPrimera: any = {};
  public valoracionesCualitativasSegunda: any = {};

  public segundaOportunidadActiva = false;

  public evaluacionGuardada1 = false;
  public evaluacionGuardada2 = false;
  public evaluacionGuardadaFinal = false;

  public resultadoCualitativo: any = '';
  public totalResultadoCualitativo: any = '';

  /**
   * Devuelve el total de artículos
   *
   * @memberof RevisionMixin
   */
  get totalArticulos(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionCientifica?.articulosCientifica?.totalProducto;
  }

  /**
   * Devuelve el total de artículos principales
   *
   * @memberof RevisionMixin
   */
  get totalArticulosPrincipal(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionCientifica?.articulosCientifica?.totalProductoPrincipal;
  }

  /**
   * Devuelve el total Producto Autor Correspondencia Principal
   *
   * @memberof RevisionMixin
   */
  get totalProductoAutorCorrespondenciaPrincipal(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionCientifica?.capitulosCientifica?.totalProductoAutorCorrespondenciaPrincipal;
  }

  /**
   * Devuelve el total Prólogos y estudios introductorios
   *
   * @memberof RevisionMixin
   */
  get totalReportes(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionCientifica?.reportes?.totalProducto;
  }

  /**
   * Devuelve el total informes
   *
   * @memberof RevisionMixin
   */
  get totalInformes(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionCientifica?.informes?.totalProducto;
  }

  /**
   * Devuelve el total dossier
   *
   * @memberof RevisionMixin
   */
  get totalDossier(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionCientifica?.dossier?.totalProducto;
  }

  /**
   * Devuelve el total antologias
   *
   * @memberof RevisionMixin
   */
  get totalAntologias(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionCientifica?.antologias?.totalProducto;
  }

  /**
   * Devuelve el total traducciones
   *
   * @memberof RevisionMixin
   */
  get totalTraducciones(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionCientifica?.traducciones?.totalProducto;
  }

  /**
   * Devuelve el total Prólogos y estudios introductorios
   *
   * @memberof RevisionMixin
   */
  get totalPrologoEstudioIntroductorio(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionCientifica?.prologoEstudioIntroductorio?.totalProducto;
  }

  /**
   * Devuelve el total curaduria
   *
   * @memberof RevisionMixin
   */
  get totalCuraduria(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionCientifica?.curaduria?.totalProducto;
  }

  /**
   * Devuelve el total desarrollo  Base Datos Primarios
   *
   * @memberof RevisionMixin
   */
  get totalBaseDatosPrimarios(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionCientifica?.baseDatosPrimarios?.totalProducto;
  }

  /**
   * Devuelve el total Producto Autor Principal CoAutor
   *
   * @memberof RevisionMixin
   */
  get totalProductoAutorPrincipalCoAutor(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionCientifica?.librosCientifica?.totalProductoAutorPrincipalCoAutor;
  }

  /**
   * Devuelve el total Producto Propiedad Intelectual Otorgada
   *
   * @memberof RevisionMixin
   */
  get totalProductoPropiedadIntelectualOtorgada(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.propiedadIntelectual?.totalProductoPropiedadIntelectualOtorgada;
  }

  /**
   * Devuelve el total de Desarrollo tecnológico e innovación
   *
   * @memberof RevisionMixin
   */
  get totalDesarrolloTecno(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.desarrolloTecnologicoInnovacion?.totalProducto;
  }

  /**
   * Devuelve el total Transferencia de tecnológica
   *
   * @memberof RevisionMixin
   */
  get totalTransferenciatecno(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.transferenciaTecnologica?.totalProducto;
  }

  /**
   * Devuelve el total de Capitulos Principales
   *
   * @memberof RevisionMixin
   */
  get totalCapitulosPrincipal(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionCientifica?.capitulosCientifica?.totalProductoPrincipal;
  }

  /**
   * Devuelve el total de Libros
   *
   * @memberof RevisionMixin
   */
  get totalLibros(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionCientifica?.librosCientifica?.totalProducto;
  }

  /**
   * Devuelve el total de Libros Principales
   *
   * @memberof RevisionMixin
   */
  get totalLibrosPrincipal(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionCientifica?.librosCientifica?.totalProductoPrincipal;
  }

  /**
   * Devuelve el total de Desarrollo tecnológico e innovación Principales
   *
   * @memberof RevisionMixin
   */
  get totalDesarrolloTecnoPrincipal(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.desarrolloTecnologicoInnovacion?.totalProductoPrincipal;
  }

  /**
   * Devuelve el total de Propiedad intelectual
   *
   * @memberof RevisionMixin
   */
  get totalPropiedadintelectual(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.propiedadIntelectual?.totalProducto;
  }

  /**
   * Devuelve el total de Propiedad intelectual Principales
   *
   * @memberof RevisionMixin
   */
  get totalPropiedadintelectualPrincipal(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.propiedadIntelectual?.totalProductoPrincipal;
  }

  /**
   * Devuelve el total  Transferencia de tecnológica Principales
   *
   * @memberof RevisionMixin
   */
  get totalTransferenciatecnoPrincipal(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.transferenciaTecnologica?.totalProductoPrincipal;
  }

  /**
   * Devuelve el total Acceso Universal
   *
   * @memberof RevisionMixin
   */
  get totalAccesoUniversalArticulos(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesAccesoUniversal?.articulosDifusion?.totalProducto;
  }

  /**
   * Devuelve el total  Acceso Universal Principales
   *
   * @memberof RevisionMixin
   */
  get totalAccesoUniversalPrincipalArticulos(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesAccesoUniversal?.articulosDifusion?.totalProductoPrincipal;
  }

  /**
   * Devuelve el total Acceso Universal
   *
   * @memberof RevisionMixin
   */
  get totalAccesoUniversalCapitulos(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesAccesoUniversal?.capitulosDifusion?.totalProducto;
  }

  /**
   * Devuelve el total  Acceso Universal Principales
   *
   * @memberof RevisionMixin
   */
  get totalAccesoUniversalPrincipalCapitulos(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesAccesoUniversal?.capitulosDifusion?.totalProductoPrincipal;
  }

  /**
   * Devuelve el total Acceso Universal
   *
   * @memberof RevisionMixin
   */
  get totalAccesoUniversalLibros(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesAccesoUniversal?.librosDifusion?.totalProducto;
  }

  /**
   * Devuelve el total  Acceso Universal Principales
   *
   * @memberof RevisionMixin
   */
  get totalAccesoUniversalPrincipalLibros(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesAccesoUniversal?.librosDifusion?.totalProductoPrincipal;
  }

  /**
   * Devuelve el total de trabajosTitulacion
   *
   * @memberof RevisionMixin
   */
  get totaltrabajosTitulacion(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesFormacionComunidad?.trabajosTitulacion?.totalProducto;
  }

  /**
   * Devuelve el total Producto Director CoDirector
   *
   * @memberof RevisionMixin
   */
  get totalProductoDirectorCoDirector(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesFormacionComunidad?.trabajosTitulacion?.totalProductoDirectorCoDirector;
  }

  /**
   * Devuelve el total de trabajosTitulacion principal
   *
   * @memberof RevisionMixin
   */
  get totaltrabajosTitulacionPrincipal(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesFormacionComunidad?.trabajosTitulacion?.totalProductoPrincipal;
  }

  /**
   * Devuelve el total de Docencia de los ultimos cinco años
   *
   * @memberof RevisionMixin
   */
  get totalProductoDocenciaCincoAnios(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesFormacionComunidad?.docencia?.totalProductoDocenciaCincoAnios;
  }

  /**
   * Devuelve el total de Docencia principal
   *
   * @memberof RevisionMixin
   */
  get totalDocenciaPrincipal(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesFormacionComunidad?.docencia?.totalProductoPrincipal;
  }

  /**
   * Devuelve el total de desarrolloInstitucional
   *
   * @memberof RevisionMixin
   */
  get totalDesarrolloInstitucional(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesFormacionComunidad?.desarrolloInstitucional?.totalProducto;
  }

  /**
   * Devuelve el total de desarrolloInstitucional principal
   *
   * @memberof RevisionMixin
   */
  get totalDesarrolloInstitucionalPrincipal(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesFormacionComunidad?.desarrolloInstitucional?.totalProductoPrincipal;
  }

  /**
   * Devuelve el total de divulgacion
   *
   * @memberof RevisionMixin
   */
  get totalDivulgacion(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesAccesoUniversal?.divulgacion?.totalProducto;
  }

  /**
   * Devuelve el total otros
   *
   * @memberof RevisionMixin
   */
  get totalOtros(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesFormacionComunidad?.otros?.totalProducto;
  }

  /**
   * Devuelve el total de Acceso Universal ó divulgacion
   *
   * @memberof RevisionMixin
   */
  get totalAccesoUniversal(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesAccesoUniversal?.totalProducto;
  }

  /**
   * Devuelve el total de divulgacion principal
   *
   * @memberof RevisionMixin
   */
  get totalDivulgacionPrincipal(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesAccesoUniversal?.divulgacion?.totalProductoPrincipal;
  }

  /**
   * Devuelve el total de Participacion en Congresos
   *
   * @memberof RevisionMixin
   */
  get totalParticipacionCongresos(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesAccesoUniversal?.participacionCongresos?.totalProducto;
  }

  /**
   * Devuelve el total de Participacion en Congresos principal
   *
   * @memberof RevisionMixin
   */
  get totalParticipacionCongresosPrincipal(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesAccesoUniversal?.participacionCongresos?.totalProductoPrincipal;
  }

  /**
   * Devuelve la clave del área
   *
   * @memberof RevisionMixin
   */
  get claveArea(): string {
    return this.solicitud.SOLICITUD_RIZOMA?.areaConocimiento.area.clave;
  }

  /**
   * Obtiene la configuración de la prelación de las áreas.
   */
  get prelacion() {
    return this.solucionPlenaria?.params?.evaluacion?.prelacion;
  }

  /**
   * Devuelve el total desarrollo Tecnologico Innovacion
   *
   * @memberof RevisionMixin
   */
  get totalDesarrolloTecnologicoInnovacion(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.desarrolloTecnologicoInnovacion?.totalProducto;
  }

  /**
   * Devuelve el total Prólogos y estudios introductorios
   *
   * @memberof RevisionMixin
   */
  get totalParticipacionEditorial(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesFormacionComunidad?.participacionEditorial?.totalProducto;
  }

  /**
   * Devuelve el total Prólogos y estudios introductorios
   *
   * @memberof RevisionMixin
   */
  get totalEventoComunicacion(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesAccesoUniversal?.eventoComunicacion?.totalProducto;
  }

  /**
   * Devuelve el total Prólogos y estudios introductorios
   *
   * @memberof RevisionMixin
   */
  get totalMuseografiaEspaciosEducacionNoFormal(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesAccesoUniversal?.museografiaEspaciosEducacionNoFormal?.totalProducto;
  }

  /**
   * Devuelve el total Prólogos y estudios introductorios
   *
   * @memberof RevisionMixin
   */
  get totalAudiovisualesRadiofonicosDigitales(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesAccesoUniversal?.audiovisualesRadiofonicosDigitales?.totalProducto;
  }

  /**
   * Devuelve el total Prólogos y estudios introductorios
   *
   * @memberof RevisionMixin
   */
  get totalMediosEscritos(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesAccesoUniversal?.mediosEscritos?.totalProducto;
  }

  /**
   * Devuelve el total Producto Desarrollo Tecnologico Lider
   *
   * @memberof RevisionMixin
   */
  get totalProductoDesarrolloTecnologicoLider(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.desarrolloTecnologicoInnovacion
      ?.totalProductoDesarrolloTecnologicoLider;
  }

  /**
   * Devuelve el total Lider TRL 4 a 6
   *
   * @memberof RevisionMixin
   */
  get totalLiderTRL4a6(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.desarrolloTecnologicoInnovacion?.totalLiderTRL4a6;
  }

  /**
   * Devuelve el total Lider TRL 7 a 9
   *
   * @memberof RevisionMixin
   */
  get totalLiderTRL7a9(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.desarrolloTecnologicoInnovacion?.totalLiderTRL7a9;
  }

  /**
   * Devuelve el total TRL 1 a 3
   *
   * @memberof RevisionMixin
   */
  get totalTRL1a3(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.desarrolloTecnologicoInnovacion?.totalTRL1a3;
  }

  /**
   * Devuelve el total TRL 4
   *
   * @memberof RevisionMixin
   */
  get totalTRL4(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.desarrolloTecnologicoInnovacion?.totalTRL4;
  }

  /**
   * Devuelve el total TRL 4 a 6
   *
   * @memberof RevisionMixin
   */
  get totalTRL4a6(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.desarrolloTecnologicoInnovacion?.totalTRL4a6;
  }

  /**
   * Devuelve el total TRL 7 a 9
   *
   * @memberof RevisionMixin
   */
  get totalTRL7a9(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.desarrolloTecnologicoInnovacion?.totalTRL7a9;
  }

  /**
   * Devuelve el nivelAspirarParametros
   *
   * @memberof RevisionMixin
   */
  get nivelAspirarParametros(): INivel {
    return this.solicitud.SOLICITUD_RIZOMA?.nivelAspirarParametros;
  }

  /**
   * Calcula el nivel recomendado de SNI en base al área y total de artículos
   *
   * @memberof RevisionMixin
   */
  public calcularNivelAsignado(): void {
    const v1 = '1';
    const v2 = '2';
    const v3 = '3';
    const v4 = '4';
    const v5 = '5';
    const v6 = '6';
    const v7 = '7';
    const v8 = '8';
    const v9 = '9';
    switch (this.claveArea) {
      case v1:
        if (this.totalArticulos >= 2 && this.totalArticulos < 4) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v1);
        } else if (this.totalArticulos >= 4 && this.totalArticulos < 9) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v2);
        } else if (this.totalArticulos >= 9 && this.totalArticulos < 20) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v3);
        } else if (this.totalArticulos >= 14) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v4);
        } else {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v1);
        }
        break;
      case v2:
        if (this.totalArticulos >= 2 && this.totalArticulos <= 4) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v1);
        } else if (this.totalArticulos >= 5 && this.totalArticulos < 10) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v2);
        } else if (this.totalArticulos >= 10 && this.totalArticulos <= 19) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v3);
        } else if (this.totalArticulos >= 20) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v4);
        } else {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v1);
        }
      case v3:
        if (this.totalArticulos >= 3 && this.totalArticulos < 6) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v1);
        } else if (this.totalArticulos >= 6 && this.totalArticulos <= 13) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v2);
        } else if (this.totalArticulos >= 11 && this.totalArticulos <= 25) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v3);
        } else if (this.totalArticulos >= 20) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v4);
        } else {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v1);
        }
      case v4:
        if (this.totalArticulos >= 2 && this.totalArticulos < 5) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v1);
        } else if (this.totalArticulos >= 5 && this.totalArticulos <= 11) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v2);
        } else if (this.totalArticulos >= 10 && this.totalArticulos < 22) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v3);
        } else if (this.totalArticulos >= 15) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v4);
        } else {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v1);
        }
      case v5:
        if (this.totalArticulos >= 1 && this.totalArticulos <= 3) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v1);
        } else if (this.totalArticulos >= 2 && this.totalArticulos <= 6) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v2);
        } else if (this.totalArticulos >= 3 && this.totalArticulos <= 9) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v3);
        } else if (this.totalArticulos >= 3) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v4);
        } else {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v1);
        }
      case v6:
        if (this.totalArticulos >= 1 && this.totalArticulos <= 4) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v1);
        } else if (this.totalArticulos >= 3 && this.totalArticulos <= 8) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v2);
        } else if (this.totalArticulos >= 4 && this.totalArticulos < 12) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v3);
        } else if (this.totalArticulos >= 5) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v4);
        } else {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v1);
        }
      case v7:
        if (this.totalArticulos >= 2 && this.totalArticulos <= 4) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v1);
        } else if (this.totalArticulos >= 5 && this.totalArticulos <= 13) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v2);
        } else if (this.totalArticulos >= 15 && this.totalArticulos <= 28) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v3);
        } else if (this.totalArticulos >= 23) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v4);
        } else {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v1);
        }
      case v8:
        if (this.totalArticulos >= 2 && this.totalArticulos <= 4) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v1);
        } else if (this.totalArticulos >= 5 && this.totalArticulos <= 11) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v2);
        } else if (this.totalArticulos >= 13 && this.totalArticulos <= 26) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v3);
        } else if (this.totalArticulos >= 19) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v4);
        } else {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v1);
        }
      case v9:
        if (this.totalArticulos >= 2 && this.totalArticulos < 5) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v1);
        } else if (this.totalArticulos >= 5 && this.totalArticulos <= 11) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v2);
        } else if (this.totalArticulos >= 9 && this.totalArticulos <= 21) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v3);
        } else if (this.totalArticulos >= 14) {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v4);
        } else {
          this.recomendado = EntityFactory.nivelesRecomendado.find(ac => ac.id === v1);
        }
      default:
        break;
    }
  }

  /**
   * Calcula la prelación de SNI en base al área y total de artículos
   *
   * @param {any} id
   * @memberof RevisionMixin
   */
  public calcularPrelacion(): void {
    if (this.solucionPlenaria?.tipo === TipoSolucion.INGRESO_PERMANENCIA_PROMOCION) {
      if (!this.prelacion) {
        this.alertService().showWarning(this, this.$t('archeApp.solucion.params.prelacion').toString(), 'danger');
        return;
      }

      if (this.recomendado.id === this.idNoAprobado) {
        this.resumen = '';
        this.validaNiveles = false;
        return;
      }

      const nivel = this.prelacion.areas.find(a => a.clave === parseInt(this.claveArea));

      if (nivel?.[this.recomendado.id]?.articulos) {
        const q1 = 'C';
        const q2 = 'B';
        const q3 = 'A';

        const nivelArticulos = nivel[this.recomendado.id].articulos;

        if (this.totalArticulos >= nivelArticulos[0] && this.totalArticulos < nivelArticulos[1]) {
          this.resumen = q1;
        } else if (this.totalArticulos >= nivelArticulos[1] && this.totalArticulos < nivelArticulos[2]) {
          this.resumen = q2;
        } else if (this.totalArticulos >= nivelArticulos[2]) {
          this.resumen = q3;
        }
        let datosEnviar = {};
        datosEnviar = {
          resumen: this.resumen,
        };
        this.guardaEvaluacion(datosEnviar);
      }
    }
  }

  public calcularPrelacion2026(): void {
    if (
      this.solucionPlenaria?.tipo === TipoSolucion.INGRESO_PERMANENCIA_PROMOCION ||
      this.solucionPlenaria?.tipo === TipoSolucion.DIASPORA
    ) {
      if (this.recomendado.id === this.idNoAprobado) {
        this.resumen = 'No aplica';
        this.validaNiveles = false;
        return;
      }

      const resultadoCualitativoGral = this.resultadoCualitativoSegunda
        ? this.resultadoCualitativoSegunda
        : this.resultadoCualitativoPrimera;

      if (resultadoCualitativoGral != null && resultadoCualitativoGral != '') {
        if (resultadoCualitativoGral == 'Alto' || resultadoCualitativoGral == 'Muy alto') {
          this.resumen = 'A';
        } else if (resultadoCualitativoGral == 'Moderado') {
          this.resumen = 'B';
        } else if (resultadoCualitativoGral == 'Bajo' || resultadoCualitativoGral == 'Muy bajo') {
          this.resumen = 'C';
        }
        let datosEnviar = {};
        datosEnviar = {
          resumen: this.resumen,
        };
        this.guardaEvaluacion(datosEnviar);
      }
    }
  }

  /**
   * Guarda una revisión
   * @param solicitud La solicitud con que estará vinculada la revisión
   * @param evaluacionId El id de la evaluación a la que pertenece la revisión
   * @param estadoRevision El estado de la revisión
   * @param respuesta La respuesta de la revisión
   * @param revisor El revisor que realizó la revisión
   */
  public guardarRevision(
    solicitud: Solicitud,
    evaluacionId: string,
    estadoRevision: EstadoRevision,
    respuesta: Respuesta,
    revisor: Revisor
  ): Promise<Revision> {
    const revision = new Revision();
    revision.estado = estadoRevision;
    revision.evaluacionId = evaluacionId;
    if (respuesta) {
      revision.respuesta = respuesta;
    }
    if (revisor) {
      revision.revisor = revisor;
    }
    revision.solicitudResumen = new SolicitudResumen(solicitud.solucionId, solicitud.id, solicitud.nombre);
    return this.revisionService()
      .create(revision)
      .then(respRevision => {
        revision.id = respRevision.id;
        return Promise.resolve(revision);
      })
      .catch(error => {
        return Promise.reject(error);
      });
  }

  /** Consulta genérica para la obtención de
   * la solicitud y N revisiones, los parámetros
   * de consulta se añaden a paginationQuery.
   */
  getRevisiones(paginationQuery): void {
    this.revisionService()
      .getRevisionAllSolicitudAll(paginationQuery)
      .then(solicitudRevisiones => {
        this.solicitudRevisiones = solicitudRevisiones.data;
      });
  }

  /**
   * Guarda la evaluación dependiendo los datos proporcionados
   *
   */
  public guardaEvaluacion(revision: Revision) {
    this.$emit('guardarEvaluacion', revision);
  }

  /**
   * Guarda las opciones seleccionadas en la tabla cualitativa.
   * Cada campo almacena solo la descripción para que funcione el v-model.
   *
   * Ejemplo:
   * relevante: "Alta"
   */
  public valoracionesCualitativas: any = {
    relevante: null,
    pertinente: null,
    sostenida: null,
    diversa: null,

    comprometidoFormacion: null,
    colaborativo: null,
    constante: null,

    inclusivaGratuita: null,
    comprensible: null,
  };

  /**
   * Valida si todas las valoraciones cualitativas ya fueron capturadas.
   * Regresa true solo cuando las 9 cualidades tienen una opción seleccionada.
   * Los campos vacíos deben mantenerse en null.
   */
  get todasValoracionesCapturadas(): boolean {
    return (
      this.valoracionesCualitativas.relevante != null &&
      this.valoracionesCualitativas.pertinente != null &&
      this.valoracionesCualitativas.sostenida != null &&
      this.valoracionesCualitativas.diversa != null &&
      this.valoracionesCualitativas.comprometidoFormacion != null &&
      this.valoracionesCualitativas.colaborativo != null &&
      this.valoracionesCualitativas.constante != null &&
      this.valoracionesCualitativas.inclusivaGratuita != null &&
      this.valoracionesCualitativas.comprensible != null
    );
  }

  /**
   * name
   */
  @Watch('todasValoracionesCapturadas', { deep: true })
  public async obtenerValoracionesCapturadas() {
    if (this.evaluacionGuardada1 && this.evaluacionGuardada2) {
      return;
    }
    if (this.todasValoracionesCapturadas) {
      await this.totalValoracionesCualitativasComponenteUno();
      await this.totalValoracionesCualitativasComponenteDos();
      await this.totalValoracionesCualitativasComponenteTres();
      await this.calculoCualitativoNivelAsignado();
      if (!this.segundaOportunidadActiva && !this.evaluacionGuardada1) {
        this.guardarValoracionesPrimera();
        this.evaluacionGuardada1 = true;
      } else if (this.segundaOportunidadActiva && this.evaluacion2.id) {
        this.guardarValoracionesSegunda();
      }
    }
  }

  /**
   * totalValoracionesCualitativas
   */
  public totalValoracionesCualitativasComponenteUno(): number {
    return (
      this.valoracionesCualitativas.relevante?.value +
      this.valoracionesCualitativas.pertinente?.value +
      this.valoracionesCualitativas.sostenida?.value +
      this.valoracionesCualitativas.diversa?.value
    );
  }

  /**
   * totalValoracionesCualitativas
   */
  public totalValoracionesCualitativasComponenteDos(): number {
    return (
      this.valoracionesCualitativas.comprometidoFormacion?.value +
      this.valoracionesCualitativas.colaborativo?.value +
      this.valoracionesCualitativas.constante?.value
    );
  }

  /**
   * totalValoracionesCualitativas
   */
  public totalValoracionesCualitativasComponenteTres(): number {
    return this.valoracionesCualitativas.inclusivaGratuita?.value + this.valoracionesCualitativas.comprensible?.value;
  }

  /**
   * Busca nivel candidato, en caso afirmativo activa bandera
   *
   * @memberof EvaluacionIndividualComponet
   */
  public validaCandidato() {
    if (this.solicitud.SOLICITUD_RIZOMA.vigencias.length > 0) {
      for (const vigencia of this.solicitud.SOLICITUD_RIZOMA.vigencias) {
        if (vigencia.cveNivelSni === 'C') {
          this.tieneCandidato = true;
        }
      }
    }
  }
  /**
   * calculo
   */
  public async calculoCualitativoNivelAsignado() {
    if (this.nivelAspirarParametros?.id == null || this.nivelAspirarParametros?.id === '6') {
      return;
    }
    const candidato = '1';
    const nivel1 = '2';
    const nivel2 = '3';
    const nivel3 = '4';
    const noAprobado = '5';

    this.validaCandidato();

    this.resultadoCualitativo = '';
    this.totalResultadoCualitativo = 0;

    this.mostrarTieneCandidato = false;

    const primero = this.totalValoracionesCualitativasComponenteUno() * 0.6;
    const segundo = this.totalValoracionesCualitativasComponenteDos() * 0.2;
    const tercero = this.totalValoracionesCualitativasComponenteTres() * 0.2;

    const totalSumaValoracionesCualitativas = primero + segundo + tercero;

    switch (this.nivelAspirarParametros.id) {
      case candidato:
        /// MUY ALTO
        if (totalSumaValoracionesCualitativas >= 12.41) {
          /// Guarda primer vuelta
          if (!this.segundaOportunidadActiva && !this.evaluacionGuardada1) {
            this.resultadoCualitativoPrimera = 'Muy alto';
            this.totalResultadoCualitativoPrimera = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasPrimera = this.valoracionesCualitativas;

            this.evaluacion1 = EntityFactory.nivelesRecomendado.find(ac => ac.id === candidato) ?? {};
          }
          // Guarda segunda
          else {
            this.resultadoCualitativoSegunda = 'Muy alto';
            this.totalResultadoCualitativoSegunda = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasSegunda = this.valoracionesCualitativas;

            this.evaluacion2 = EntityFactory.nivelesRecomendado.find(ac => ac.id === candidato) ?? {};
          }
        }
        //ALTO
        else if (totalSumaValoracionesCualitativas >= 10.22 && totalSumaValoracionesCualitativas < 12.41) {
          /// Guarda primer vuelta
          if (!this.segundaOportunidadActiva && !this.evaluacionGuardada1) {
            this.resultadoCualitativoPrimera = 'Alto';
            this.totalResultadoCualitativoPrimera = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasPrimera = this.valoracionesCualitativas;
            this.evaluacion1 = EntityFactory.nivelesRecomendado.find(ac => ac.id === candidato) ?? {};
          }
          // Guarda segunda
          else {
            this.resultadoCualitativoSegunda = 'Alto';
            this.totalResultadoCualitativoSegunda = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasSegunda = this.valoracionesCualitativas;
            this.evaluacion2 = EntityFactory.nivelesRecomendado.find(ac => ac.id === candidato) ?? {};
          }
        }
        /// MODERADO
        else if (totalSumaValoracionesCualitativas >= 8.03 && totalSumaValoracionesCualitativas < 10.22) {
          /// Guarda primer vuelta
          if (!this.segundaOportunidadActiva && !this.evaluacionGuardada1) {
            this.resultadoCualitativoPrimera = 'Moderado';
            this.totalResultadoCualitativoPrimera = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasPrimera = this.valoracionesCualitativas;
            this.evaluacion1 = EntityFactory.nivelesRecomendado.find(ac => ac.id === noAprobado) ?? {};
          }
          // Guarda segunda
          else {
            this.resultadoCualitativoSegunda = 'Moderado';
            this.totalResultadoCualitativoSegunda = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasSegunda = this.valoracionesCualitativas;
            this.evaluacion2 = EntityFactory.nivelesRecomendado.find(ac => ac.id === noAprobado) ?? {};
          }
        }
        // BAJO
        else if (totalSumaValoracionesCualitativas >= 5.84 && totalSumaValoracionesCualitativas < 8.03) {
          /// Guarda primer vuelta
          if (!this.segundaOportunidadActiva && !this.evaluacionGuardada1) {
            this.resultadoCualitativoPrimera = 'Bajo';
            this.totalResultadoCualitativoPrimera = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasPrimera = this.valoracionesCualitativas;
            this.evaluacion1 = EntityFactory.nivelesRecomendado.find(ac => ac.id === noAprobado) ?? {};
          }
          // Guarda segunda
          else {
            this.resultadoCualitativoSegunda = 'Bajo';
            this.totalResultadoCualitativoSegunda = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasSegunda = this.valoracionesCualitativas;
            this.evaluacion2 = EntityFactory.nivelesRecomendado.find(ac => ac.id === noAprobado) ?? {};
          }
        }
        /// MUY BAJO
        else if (totalSumaValoracionesCualitativas < 5.84) {
          /// Guarda primer vuelta
          if (!this.segundaOportunidadActiva && !this.evaluacionGuardada1) {
            this.resultadoCualitativoPrimera = 'Muy bajo';
            this.totalResultadoCualitativoPrimera = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasPrimera = this.valoracionesCualitativas;
            this.evaluacion1 = EntityFactory.nivelesRecomendado.find(ac => ac.id === noAprobado) ?? {};
          }
          // Guarda segunda
          else {
            this.resultadoCualitativoSegunda = 'Muy bajo';
            this.totalResultadoCualitativoSegunda = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasSegunda = this.valoracionesCualitativas;
            this.evaluacion2 = EntityFactory.nivelesRecomendado.find(ac => ac.id === noAprobado) ?? {};
          }
        }
        break;
      case nivel1:
        /// MUY ALTO
        if (totalSumaValoracionesCualitativas >= 13.43) {
          /// Guarda primer vuelta
          if (!this.segundaOportunidadActiva && !this.evaluacionGuardada1) {
            this.resultadoCualitativoPrimera = 'Muy alto';
            this.totalResultadoCualitativoPrimera = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasPrimera = this.valoracionesCualitativas;
            this.evaluacion1 = EntityFactory.nivelesRecomendado.find(ac => ac.id === nivel1) ?? {};
          }
          // Guarda segunda
          else {
            this.resultadoCualitativoSegunda = 'Muy alto';
            this.totalResultadoCualitativoSegunda = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasSegunda = this.valoracionesCualitativas;
            this.evaluacion2 = EntityFactory.nivelesRecomendado.find(ac => ac.id === nivel1) ?? {};
          }
        }
        /// ALTO
        else if (totalSumaValoracionesCualitativas >= 11.6 && totalSumaValoracionesCualitativas < 13.43) {
          /// Guarda primer vuelta
          if (!this.segundaOportunidadActiva && !this.evaluacionGuardada1) {
            this.resultadoCualitativoPrimera = 'Alto';
            this.totalResultadoCualitativoPrimera = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasPrimera = this.valoracionesCualitativas;
            this.evaluacion1 = EntityFactory.nivelesRecomendado.find(ac => ac.id === nivel1) ?? {};
          }
          // Guarda segunda
          else {
            this.resultadoCualitativoSegunda = 'Alto';
            this.totalResultadoCualitativoSegunda = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasSegunda = this.valoracionesCualitativas;
            this.evaluacion2 = EntityFactory.nivelesRecomendado.find(ac => ac.id === nivel1) ?? {};
          }
        }
        /// MODERADO: Se valida si ya fue candidato
        else if (totalSumaValoracionesCualitativas >= 8.69 && totalSumaValoracionesCualitativas < 11.6) {
          /// Guarda primer vuelta
          if (!this.segundaOportunidadActiva && !this.evaluacionGuardada1) {
            if (this.tieneCandidato) {
              this.mostrarTieneCandidato = true;
              this.evaluacion1 = EntityFactory.nivelesRecomendado.find(ac => ac.id === noAprobado) ?? {};
            } else {
              this.evaluacion1 = EntityFactory.nivelesRecomendado.find(ac => ac.id === candidato) ?? {};
            }
            this.resultadoCualitativoPrimera = 'Moderado';
            this.totalResultadoCualitativoPrimera = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasPrimera = this.valoracionesCualitativas;
          }
          // Guarda segunda
          else {
            if (this.tieneCandidato) {
              this.mostrarTieneCandidato = true;
              this.evaluacion2 = EntityFactory.nivelesRecomendado.find(ac => ac.id === noAprobado) ?? {};
            } else {
              this.evaluacion2 = EntityFactory.nivelesRecomendado.find(ac => ac.id === candidato) ?? {};
            }

            this.resultadoCualitativoSegunda = 'Moderado';
            this.totalResultadoCualitativoSegunda = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasSegunda = this.valoracionesCualitativas;
          }
        }
        /// BAJO
        else if (totalSumaValoracionesCualitativas >= 6.32 && totalSumaValoracionesCualitativas < 8.69) {
          /// Guarda primer vuelta
          if (!this.segundaOportunidadActiva && !this.evaluacionGuardada1) {
            this.resultadoCualitativoPrimera = 'Bajo';
            this.totalResultadoCualitativoPrimera = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasPrimera = this.valoracionesCualitativas;
            this.evaluacion1 = EntityFactory.nivelesRecomendado.find(ac => ac.id === noAprobado) ?? {};
          }
          // Guarda segunda
          else {
            this.resultadoCualitativoSegunda = 'Bajo';
            this.totalResultadoCualitativoSegunda = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasSegunda = this.valoracionesCualitativas;
            this.evaluacion2 = EntityFactory.nivelesRecomendado.find(ac => ac.id === noAprobado) ?? {};
          }
        }
        /// MUY BAJO
        else if (totalSumaValoracionesCualitativas < 6.32) {
          /// Guarda primer vuelta
          if (!this.segundaOportunidadActiva && !this.evaluacionGuardada1) {
            this.resultadoCualitativoPrimera = 'Muy bajo';
            this.totalResultadoCualitativoPrimera = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasPrimera = this.valoracionesCualitativas;
            this.evaluacion1 = EntityFactory.nivelesRecomendado.find(ac => ac.id === noAprobado) ?? {};
          }
          // Guarda segunda
          else {
            this.resultadoCualitativoSegunda = 'Muy bajo';
            this.totalResultadoCualitativoSegunda = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasSegunda = this.valoracionesCualitativas;
            this.evaluacion2 = EntityFactory.nivelesRecomendado.find(ac => ac.id === noAprobado) ?? {};
          }
        }
        break;
      case nivel2:
        /// MUY ALTO
        if (totalSumaValoracionesCualitativas >= 13.43) {
          /// Guarda primer vuelta
          if (!this.segundaOportunidadActiva && !this.evaluacionGuardada1) {
            this.resultadoCualitativoPrimera = 'Muy alto';
            this.totalResultadoCualitativoPrimera = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasPrimera = this.valoracionesCualitativas;
            this.evaluacion1 = EntityFactory.nivelesRecomendado.find(ac => ac.id === nivel2) ?? {};
          }
          // Guarda segunda
          else {
            this.resultadoCualitativoSegunda = 'Muy alto';
            this.totalResultadoCualitativoSegunda = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasSegunda = this.valoracionesCualitativas;
            this.evaluacion2 = EntityFactory.nivelesRecomendado.find(ac => ac.id === nivel2) ?? {};
          }
          /// ALTO
        } else if (totalSumaValoracionesCualitativas >= 11.6 && totalSumaValoracionesCualitativas < 13.43) {
          /// Guarda primer vuelta
          if (!this.segundaOportunidadActiva && !this.evaluacionGuardada1) {
            this.resultadoCualitativoPrimera = 'Alto';
            this.totalResultadoCualitativoPrimera = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasPrimera = this.valoracionesCualitativas;
            this.evaluacion1 = EntityFactory.nivelesRecomendado.find(ac => ac.id === nivel2) ?? {};
          }
          // Guarda segunda
          else {
            this.resultadoCualitativoSegunda = 'Alto';
            this.totalResultadoCualitativoSegunda = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasSegunda = this.valoracionesCualitativas;
            this.evaluacion2 = EntityFactory.nivelesRecomendado.find(ac => ac.id === nivel2) ?? {};
          }
          /// MODERADO
        } else if (totalSumaValoracionesCualitativas >= 8.69 && totalSumaValoracionesCualitativas < 11.6) {
          /// Guarda primer vuelta
          if (!this.segundaOportunidadActiva && !this.evaluacionGuardada1) {
            this.resultadoCualitativoPrimera = 'Moderado';
            this.totalResultadoCualitativoPrimera = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasPrimera = this.valoracionesCualitativas;
            this.evaluacion1 = EntityFactory.nivelesRecomendado.find(ac => ac.id === nivel1) ?? {};
          }
          // Guarda segunda
          else {
            this.resultadoCualitativoSegunda = 'Moderado';
            this.totalResultadoCualitativoSegunda = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasSegunda = this.valoracionesCualitativas;
            this.evaluacion2 = EntityFactory.nivelesRecomendado.find(ac => ac.id === nivel1) ?? {};
          }
        }
        /// BAJO
        else if (totalSumaValoracionesCualitativas >= 6.32 && totalSumaValoracionesCualitativas < 8.69) {
          /// Guarda primer vuelta
          if (!this.segundaOportunidadActiva && !this.evaluacionGuardada1) {
            this.resultadoCualitativoPrimera = 'Bajo';
            this.totalResultadoCualitativoPrimera = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasPrimera = this.valoracionesCualitativas;
            this.evaluacion1 = EntityFactory.nivelesRecomendado.find(ac => ac.id === nivel1) ?? {};
          }
          // Guarda segunda
          else {
            this.resultadoCualitativoSegunda = 'Bajo';
            this.totalResultadoCualitativoSegunda = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasSegunda = this.valoracionesCualitativas;
            this.evaluacion2 = EntityFactory.nivelesRecomendado.find(ac => ac.id === nivel1) ?? {};
          }
        }
        /// MUY BAJO
        else if (totalSumaValoracionesCualitativas < 6.32) {
          /// Guarda primer vuelta
          if (!this.segundaOportunidadActiva && !this.evaluacionGuardada1) {
            this.resultadoCualitativoPrimera = 'Muy bajo';
            this.totalResultadoCualitativoPrimera = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasPrimera = this.valoracionesCualitativas;
            this.evaluacion1 = EntityFactory.nivelesRecomendado.find(ac => ac.id === nivel1) ?? {};
          }
          // Guarda segunda
          else {
            this.resultadoCualitativoSegunda = 'Muy bajo';
            this.totalResultadoCualitativoSegunda = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasSegunda = this.valoracionesCualitativas;
            this.evaluacion2 = EntityFactory.nivelesRecomendado.find(ac => ac.id === nivel1) ?? {};
          }
        }
        break;
      case nivel3:
        /// MUY ALTO
        if (totalSumaValoracionesCualitativas >= 13.43) {
          /// Guarda primer vuelta
          if (!this.segundaOportunidadActiva && !this.evaluacionGuardada1) {
            this.resultadoCualitativoPrimera = 'Muy alto';
            this.totalResultadoCualitativoPrimera = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasPrimera = this.valoracionesCualitativas;
            this.evaluacion1 = EntityFactory.nivelesRecomendado.find(ac => ac.id === nivel3) ?? {};
          }
          // Guarda segunda
          else {
            this.resultadoCualitativoSegunda = 'Muy alto';
            this.totalResultadoCualitativoSegunda = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasSegunda = this.valoracionesCualitativas;
            this.evaluacion2 = EntityFactory.nivelesRecomendado.find(ac => ac.id === nivel3) ?? {};
          }
          /// ALTO
        } else if (totalSumaValoracionesCualitativas >= 11.6 && totalSumaValoracionesCualitativas < 13.43) {
          /// Guarda primer vuelta
          if (!this.segundaOportunidadActiva && !this.evaluacionGuardada1) {
            this.resultadoCualitativoPrimera = 'Alto';
            this.totalResultadoCualitativoPrimera = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasPrimera = this.valoracionesCualitativas;
            this.evaluacion1 = EntityFactory.nivelesRecomendado.find(ac => ac.id === nivel3) ?? {};
          }
          // Guarda segunda
          else {
            this.resultadoCualitativoSegunda = 'Alto';
            this.totalResultadoCualitativoSegunda = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasSegunda = this.valoracionesCualitativas;
            this.evaluacion2 = EntityFactory.nivelesRecomendado.find(ac => ac.id === nivel3) ?? {};
          }
          /// MODERADO
        } else if (totalSumaValoracionesCualitativas >= 8.69 && totalSumaValoracionesCualitativas < 11.6) {
          /// Guarda primer vuelta
          if (!this.segundaOportunidadActiva && !this.evaluacionGuardada1) {
            this.resultadoCualitativoPrimera = 'Moderado';
            this.totalResultadoCualitativoPrimera = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasPrimera = this.valoracionesCualitativas;
            this.evaluacion1 = EntityFactory.nivelesRecomendado.find(ac => ac.id === nivel2) ?? {};
          }
          // Guarda segunda
          else {
            this.resultadoCualitativoSegunda = 'Moderado';
            this.totalResultadoCualitativoSegunda = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasSegunda = this.valoracionesCualitativas;
            this.evaluacion2 = EntityFactory.nivelesRecomendado.find(ac => ac.id === nivel2) ?? {};
          }
        }
        /// BAJO
        else if (totalSumaValoracionesCualitativas >= 6.32 && totalSumaValoracionesCualitativas < 8.69) {
          /// Guarda primer vuelta
          if (!this.segundaOportunidadActiva && !this.evaluacionGuardada1) {
            this.resultadoCualitativoPrimera = 'Bajo';
            this.totalResultadoCualitativoPrimera = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasPrimera = this.valoracionesCualitativas;
            this.evaluacion1 = EntityFactory.nivelesRecomendado.find(ac => ac.id === nivel2) ?? {};
          }
          // Guarda segunda
          else {
            this.resultadoCualitativoSegunda = 'Bajo';
            this.totalResultadoCualitativoSegunda = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasSegunda = this.valoracionesCualitativas;
            this.evaluacion2 = EntityFactory.nivelesRecomendado.find(ac => ac.id === nivel2) ?? {};
          }
        }
        /// MUY BAJO
        else if (totalSumaValoracionesCualitativas < 6.32) {
          /// Guarda primer vuelta
          if (!this.segundaOportunidadActiva && !this.evaluacionGuardada1) {
            this.resultadoCualitativoPrimera = 'Muy bajo';
            this.totalResultadoCualitativoPrimera = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasPrimera = this.valoracionesCualitativas;
            this.evaluacion1 = EntityFactory.nivelesRecomendado.find(ac => ac.id === nivel1) ?? {};
          }
          // Guarda segunda
          else {
            this.resultadoCualitativoSegunda = 'Muy bajo';
            this.totalResultadoCualitativoSegunda = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasSegunda = this.valoracionesCualitativas;
            this.evaluacion2 = EntityFactory.nivelesRecomendado.find(ac => ac.id === nivel1) ?? {};
          }
        }
        break;
      case noAprobado:
        /// MUY ALTO
        if (totalSumaValoracionesCualitativas >= 12.41) {
          /// Guarda primer vuelta
          if (!this.segundaOportunidadActiva && !this.evaluacionGuardada1) {
            this.resultadoCualitativoPrimera = 'Muy alto';
            this.totalResultadoCualitativoPrimera = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasPrimera = this.valoracionesCualitativas;

            this.evaluacion1 = EntityFactory.nivelesRecomendado.find(ac => ac.id === noAprobado) ?? {};
          }
          // Guarda segunda
          else {
            this.resultadoCualitativoSegunda = 'Muy alto';
            this.totalResultadoCualitativoSegunda = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasSegunda = this.valoracionesCualitativas;

            this.evaluacion2 = EntityFactory.nivelesRecomendado.find(ac => ac.id === noAprobado) ?? {};
          }
        }
        //ALTO
        else if (totalSumaValoracionesCualitativas >= 10.22 && totalSumaValoracionesCualitativas < 12.41) {
          /// Guarda primer vuelta
          if (!this.segundaOportunidadActiva && !this.evaluacionGuardada1) {
            this.resultadoCualitativoPrimera = 'Alto';
            this.totalResultadoCualitativoPrimera = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasPrimera = this.valoracionesCualitativas;
            this.evaluacion1 = EntityFactory.nivelesRecomendado.find(ac => ac.id === noAprobado) ?? {};
          }
          // Guarda segunda
          else {
            this.resultadoCualitativoSegunda = 'Alto';
            this.totalResultadoCualitativoSegunda = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasSegunda = this.valoracionesCualitativas;
            this.evaluacion2 = EntityFactory.nivelesRecomendado.find(ac => ac.id === noAprobado) ?? {};
          }
        }
        /// MODERADO
        else if (totalSumaValoracionesCualitativas >= 8.03 && totalSumaValoracionesCualitativas < 10.22) {
          /// Guarda primer vuelta
          if (!this.segundaOportunidadActiva && !this.evaluacionGuardada1) {
            this.resultadoCualitativoPrimera = 'Moderado';
            this.totalResultadoCualitativoPrimera = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasPrimera = this.valoracionesCualitativas;
            this.evaluacion1 = EntityFactory.nivelesRecomendado.find(ac => ac.id === noAprobado) ?? {};
          }
          // Guarda segunda
          else {
            this.resultadoCualitativoSegunda = 'Moderado';
            this.totalResultadoCualitativoSegunda = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasSegunda = this.valoracionesCualitativas;
            this.evaluacion2 = EntityFactory.nivelesRecomendado.find(ac => ac.id === noAprobado) ?? {};
          }
        }
        // BAJO
        else if (totalSumaValoracionesCualitativas >= 5.84 && totalSumaValoracionesCualitativas < 8.03) {
          /// Guarda primer vuelta
          if (!this.segundaOportunidadActiva && !this.evaluacionGuardada1) {
            this.resultadoCualitativoPrimera = 'Bajo';
            this.totalResultadoCualitativoPrimera = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasPrimera = this.valoracionesCualitativas;
            this.evaluacion1 = EntityFactory.nivelesRecomendado.find(ac => ac.id === noAprobado) ?? {};
          }
          // Guarda segunda
          else {
            this.resultadoCualitativoSegunda = 'Bajo';
            this.totalResultadoCualitativoSegunda = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasSegunda = this.valoracionesCualitativas;
            this.evaluacion2 = EntityFactory.nivelesRecomendado.find(ac => ac.id === noAprobado) ?? {};
          }
        }
        /// MUY BAJO
        else if (totalSumaValoracionesCualitativas < 5.84) {
          /// Guarda primer vuelta
          if (!this.segundaOportunidadActiva && !this.evaluacionGuardada1) {
            this.resultadoCualitativoPrimera = 'Muy bajo';
            this.totalResultadoCualitativoPrimera = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasPrimera = this.valoracionesCualitativas;
            this.evaluacion1 = EntityFactory.nivelesRecomendado.find(ac => ac.id === noAprobado) ?? {};
          }
          // Guarda segunda
          else {
            this.resultadoCualitativoSegunda = 'Muy bajo';
            this.totalResultadoCualitativoSegunda = totalSumaValoracionesCualitativas;
            this.valoracionesCualitativasSegunda = this.valoracionesCualitativas;
            this.evaluacion2 = EntityFactory.nivelesRecomendado.find(ac => ac.id === noAprobado) ?? {};
          }
        }
        break;
      default:
        break;
    }
  }

  public tablaCualitativaBloqueada = false;
  /**
   * guardarValoraciones
   */
  public guardarValoracionesPrimera() {
    this.recomendado = this.evaluacion1;
    if (!this.evaluacionIndividual) {
      this.calcularPrelacionPlenaria2026();
    }
    const datosEnviar: any = {
      evaluacion: this.evaluacion1,
      evaluacion1: this.evaluacion1,

      totalResultadoCualitativoPrimera: this.totalResultadoCualitativoPrimera,
      resultadoCualitativoPrimera: this.resultadoCualitativoPrimera,
      valoracionesCualitativasPrimera: this.valoracionesCualitativasPrimera,

      evaluacionGuardada1: true,
    };

    if (!this.evaluacionIndividual) {
      datosEnviar.resumen = this.resumen;
    }

    this.guardaEvaluacion(datosEnviar);
    this.tablaCualitativaBloqueada = true;
    this.evaluacionGuardada1 = true;
  }

  /**
   * guardarValoraciones
   */
  public guardarValoracionesSegunda() {
    this.recomendado = this.evaluacion2;
    if (!this.evaluacionIndividual) {
      this.calcularPrelacionPlenaria2026();
    }
    const datosEnviar: any = {
      evaluacion: this.evaluacion2,
      evaluacion2: this.evaluacion2,

      totalResultadoCualitativoSegunda: this.totalResultadoCualitativoSegunda,
      resultadoCualitativoSegunda: this.resultadoCualitativoSegunda,
      valoracionesCualitativasSegunda: this.valoracionesCualitativasSegunda,
      segundaOportunidadActiva: this.segundaOportunidadActiva,
      evaluacionGuardada2: true,
    };

    if (!this.evaluacionIndividual) {
      datosEnviar.resumen = this.resumen;
    }

    this.guardaEvaluacion(datosEnviar);
    this.tablaCualitativaBloqueada = true;
    this.evaluacionGuardada2 = true;
  }

  public calcularPrelacionPlenaria2026(): void {
    if (this.recomendado.id === this.idNoAprobado) {
      this.resumen = 'No aplica';
      this.validaNiveles = false;
      return;
    }

    const resultadoCualitativoGral = this.resultadoCualitativoSegunda ? this.resultadoCualitativoSegunda : this.resultadoCualitativoPrimera;

    if (resultadoCualitativoGral != null && resultadoCualitativoGral != '') {
      if (resultadoCualitativoGral == 'Alto' || resultadoCualitativoGral == 'Muy alto') {
        this.resumen = 'A';
      } else if (resultadoCualitativoGral == 'Moderado') {
        this.resumen = 'B';
      } else if (resultadoCualitativoGral == 'Bajo' || resultadoCualitativoGral == 'Muy bajo') {
        this.resumen = 'C';
      }
    }
  }

  get totalProductosComponente1(): number {
    return (
      (this.totalArticulos ?? 0) +
      (this.totalProductoAutorCorrespondenciaPrincipal ?? 0) +
      (this.totalReportes ?? 0) +
      (this.totalInformes ?? 0) +
      (this.totalDossier ?? 0) +
      (this.totalAntologias ?? 0) +
      (this.totalTraducciones ?? 0) +
      (this.totalPrologoEstudioIntroductorio ?? 0) +
      (this.totalCuraduria ?? 0) +
      (this.totalBaseDatosPrimarios ?? 0) +
      (this.totalProductoAutorPrincipalCoAutor ?? 0) +
      (this.totalDesarrolloTecno ?? 0) +
      (this.totalTransferenciatecno ?? 0) +
      (this.totalProductoPropiedadIntelectualOtorgada ?? 0)
    );
  }

  get totalProductosComponente2(): number {
    if (this.solicitudRizomaActual.nivelAspira.id === '1' || this.solicitudRizomaActual.nivelAspira.id === '2') {
      return (
        (this.totalProductoDocenciaCincoAnios ?? 0) +
        (this.totalDesarrolloInstitucional ?? 0) +
        (this.totaltrabajosTitulacion ?? 0) +
        (this.totalOtros ?? 0)
      );
    } else {
      return (
        (this.totalProductoDocenciaCincoAnios ?? 0) +
        (this.totalDesarrolloInstitucional ?? 0) +
        (this.totalProductoDirectorCoDirector ?? 0) +
        (this.totalOtros ?? 0)
      );
    }
  }

  /**
   * Obtiene la información Rizoma de la solicitud actual.
   */
  get solicitudRizomaActual(): any {
    const solicitudAny: any = this.solicitud;

    return solicitudAny?.SOLICITUD_RIZOMA || solicitudAny?.properties?.SOLICITUD_RIZOMA || {};
  }
}
